(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pfp-mobile-rails"] && !Shopify.designMode) return;
  try {
    (()=>{
  if(!customElements.get('pf-mobile-rail')){
    class PfMobileRail extends HTMLElement{
      connectedCallback(){
        this.track=this.querySelector(':scope > .pfm-track');
        if(!this.track)return;
        this.mobile=matchMedia('(max-width:749px)');
        this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
        this.rebuild=()=>this.build();
        this.mobile.addEventListener('change',this.rebuild);
        this.reduced.addEventListener('change',this.rebuild);
        this.observer=new IntersectionObserver(entries=>{
          this.toggleAttribute('data-visible',entries[0].isIntersecting);
        });
        this.observer.observe(this);
        this.resize=new ResizeObserver(()=>this.measure());
        this.resize.observe(this);
        this.resize.observe(this.track);
        this.build();
      }
      clear(){
        this.track.querySelectorAll(':scope > [data-pfm-clone]').forEach(item=>item.remove());
        this.removeAttribute('data-running');
      }
      build(){
        this.clear();
        this.toggleAttribute('data-reduced',this.mobile.matches&&this.reduced.matches);
        if(!this.mobile.matches||this.reduced.matches)return;
        this.originals=[...this.track.children];
        if(this.originals.length<2)return;
        this.originals.forEach(item=>{
          const clone=item.cloneNode(true);
          clone.dataset.pfmClone='';
          clone.setAttribute('aria-hidden','true');
          clone.setAttribute('inert','');
          [clone,...clone.querySelectorAll('*')].forEach(el=>{
            el.removeAttribute('id');
            el.removeAttribute('data-shopify-editor-block');
          });
          this.track.append(clone);
        });
        this.setAttribute('data-running','');
        this.measure();
      }
      measure(){
        if(!this.hasAttribute('data-running'))return;
        const first=this.track.firstElementChild,copy=this.track.querySelector('[data-pfm-clone]');
        if(!first||!copy)return;
        const distance=copy.getBoundingClientRect().left-first.getBoundingClientRect().left;
        if(distance<=0)return;
        this.style.setProperty('--pfm-distance',distance+'px');
        this.style.setProperty('--pfm-duration',(distance/(Number(this.dataset.speed)||20))+'s');
      }
      disconnectedCallback(){
        this.observer?.disconnect();
        this.resize?.disconnect();
        this.mobile?.removeEventListener('change',this.rebuild);
        this.reduced?.removeEventListener('change',this.rebuild);
        if(this.track)this.clear();
      }
    }
    customElements.define('pf-mobile-rail',PfMobileRail);
  }
  document.addEventListener('click',event=>{
    const pause=event.target.closest('[data-pfm-pause]');
    if(pause){
      const paused=pause.getAttribute('aria-pressed')!=='true';
      pause.setAttribute('aria-pressed',String(paused));
      pause.setAttribute('aria-label',paused?pause.dataset.resume:pause.dataset.pause);
      pause.closest('[data-pfm-group]')?.querySelectorAll('pf-mobile-rail').forEach(rail=>rail.toggleAttribute('data-paused',paused));
    }
    const button=event.target.closest('[data-pfm-install-next]');
    if(!button)return;
    const track=button.closest('.pfx-install__shell')?.querySelector('.pfx-install__steps');
    if(!track)return;
    const end=track.scrollWidth-track.clientWidth;
    const first=track.firstElementChild;
    const step=(first?.getBoundingClientRect().width||track.clientWidth)+(parseFloat(getComputedStyle(track).gap)||14);
    const atEnd=track.scrollLeft>=end-8;
    track.scrollTo({left:atEnd?0:Math.min(track.scrollLeft+step,end),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  });
  const updateInstall=track=>{
    const button=track.closest('.pfx-install__shell')?.querySelector('[data-pfm-install-next]');
    if(!button)return;
    const end=track.scrollLeft>=track.scrollWidth-track.clientWidth-8;
      button.dataset.atEnd=String(end);
      button.setAttribute('aria-label',end?button.dataset.first:button.dataset.next);
  };
  const init=scope=>scope.querySelectorAll('.pfx-install__steps').forEach(track=>{
    if(track.dataset.pfmReady)return;
    track.dataset.pfmReady='true';
    track.addEventListener('scroll',()=>updateInstall(track),{passive:true});
    updateInstall(track);
  });
  window.addEventListener('resize',()=>document.querySelectorAll('.pfx-install__steps').forEach(updateInstall),{passive:true});
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
